import { fetchMostUsed } from "../../resources/DashboardResource";
import React, { useEffect, useState } from "react";

export default function MostUsedPart() {

    const [dataMostUsed, setDataMostUsed] = useState(null);

    const fetchDataMostUsed = () => {
        fetchMostUsed()
            .then((res) => {

                setDataMostUsed(res.data);
            })
            .catch((err) => {
                setDataMostUsed(null);
            });
    };

    useEffect(() => {
        fetchDataMostUsed();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            {!dataMostUsed ? <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '260px'
            }}>
                <div className="spinner-border text-primary" role="status"> <span className="visually-hidden">Loading...</span>
                </div>
            </div> : dataMostUsed.length === 0 ? <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '260px'
            }}>
                <div><span>Data is Empty</span></div>
            </div> :
                dataMostUsed.map(data => {
                    return (<div className="row align-items-baseline mt-2" key={data.id}>
                        <div className="col-auto">
                            <h6 style={{
                                width: '140px', overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                            }}>{data.part_name}</h6>
                        </div>
                        <div className="col-auto">
                            <label className="form-label" style={{
                                width: '10px',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                marginRight: '8px'
                            }}>{data.total_outbound}</label>
                        </div>
                        <div className="col">
                            <div className="progress mb-3" style={{ height: '7px' }}>
                                <div className="progress-bar" role="progressbar" style={{ width: `${data.outbound_percentage > 100 ? 100 : data.outbound_percentage}%`, backgroundColor: data.outbound_percentage >= 40 && data.outbound_percentage <= 59 ? '#BE7CFF' : data.outbound_percentage >= 60 && data.outbound_percentage <= 79 ? '#962DFF' : data.outbound_percentage >= 80 ? '#36006C' : '#D2A9FF' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                            </div>
                        </div>
                    </div>)
                })
            }

        </>)
}